import {Locales} from '@netx/core-next/locales/utils/Locales';

export const DrawerActionLabel = Locales((i18n) => ({
	COLLAPSE: i18n('i18n.collapse'),
	CLOSE: i18n('i18n.close'),
	UNCOLLAPSE: i18n('i18n.uncollapse'),
}));
